// src/components/ShoppingCart.jsx
/* global fbq */
import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import ccBanner from '../assets/images/cc_banner.png';

const ShoppingCart = ({price, productImage, isFullPage = false, onOutOfStock, onEmailCapture }) => {
    const { cart, updateQuantity } = useCart();
    const [step, setStep] = useState('cart'); // cart | shipping | payment
    const [formErrors, setFormErrors] = useState({});
    const [formData, setFormData] = useState({
        email: '',
        firstName: '', lastName: '',
        address: '', apt: '',
        city: '', state: '', zip: ''
    });

    const subtotal = cart.total;
    const shipping = 0;
    const tax = subtotal * 0.08;
    const total = subtotal + shipping + tax;

    const validateShipping = () => {
        const errors = {};

        if (!formData.email.includes('@')) errors.email = 'Valid email required';
        if (!formData.firstName.match(/^[A-Za-z]+(?:[ '-][A-Za-z]+)*$/)) errors.firstName = 'First name required';
        if (!formData.lastName.match(/^[A-Za-z]+(?:[ '-][A-Za-z]+)*$/)) errors.lastName = 'Last name required';
        if (!formData.address.trim()) errors.address = 'Street address required';
        if (!formData.city.trim()) errors.city = 'City required';
        if (!formData.state.trim()) errors.state = 'State required';
        if (!formData.zip.match(/^\d{5}(-\d{4})?$/)) errors.zip = 'Valid ZIP code required';

        setFormErrors(errors);
        return Object.keys(errors).length === 0; // true = valid
    };
    const trackLeadCapture = () => {
        // GA4 event — works with gtag.js or Google Tag Manager
        window.gtag?.('event', 'generate_lead', {
            currency: 'USD',
            value: 39.99,                    // or cart.total if you have multiple
            items: [{ item_name: 'Zenzzz Lavender Honey', quantity: cart.quantity, price: 39.99 }]
        });

    };
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (e.target.name === 'email') onEmailCapture?.(e.target.value);
    };

    if (cart.quantity === 0 && step === 'cart') {
        return (
            <div className="empty-cart-section">
                <div className="empty-cart-content">
                    <h2>Your cart is empty</h2>
                    <p>Add Zenzzz to experience deep, natural sleep</p>
                    <button className="cta-button" onClick={() =>{
                        updateQuantity(1)
                        fbq('track', "AddToCart using bottom cart");
                    }
                    }>
                        Add Zenzzz - ${price}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <section id="cart" className={isFullPage ? "shopping-cart-fullpage" : "shopping-cart-page"}>
            <div className="container">
                <div className="checkout-layout">
                    {/* Left: Form Steps */}
                    <div className="checkout-form-section">
                        {step === 'cart' && (
                            <>
                                <h2>Review Your Items</h2>
                                <div className="cart-item">
                                    <img src={productImage} alt="Zenzzz" />
                                    <div>
                                        <h4>Zenzzz Lavender Honey (30 servings)</h4>
                                        <p>$39.99 each</p>
                                        <div className="quantity-controls">
                                            <button onClick={() => {

                                                updateQuantity(-1);
                                            }} disabled={cart.quantity <= 0}>-</button>

                                            <span>{cart.quantity}</span>

                                            <button onClick={() => {
                                                updateQuantity(1);
                                            }}>+</button>
                                        </div>
                                    </div>
                                </div>
                                <button onClick={() => setStep('shipping')} className="cta-button full-width">
                                    Continue to Shipping
                                </button>
                            </>
                        )}

                        {step === 'shipping' && (
                            <>
                            <form>
                                    <h2>Shipping Details</h2>
                                <div className={`input-group ${formErrors.email ? 'invalid' : ''}`}>
                                    <input name="email" type="email" placeholder="Email"  value={formData.email} required onChange={handleInputChange} />
                                    {formErrors.email && (
                                        <div className="error-tooltip">
                                            {formErrors.email}
                                        </div>
                                    )}

                                </div>
                                <div className="grid-2">
                                    <div className={`input-group ${formErrors.firstName ? 'invalid' : ''}`}>
                                        <input name="firstName" placeholder="First Name" required onChange={handleInputChange} />
                                    {formErrors.firstName && (
                                        <div className="error-tooltip">
                                            {formErrors.firstName}
                                        </div>
                                    )}
                                    </div>
                                    <div className={`input-group ${formErrors.lastName ? 'invalid' : ''}`}>
                                        <input name="lastName" placeholder="last Name" required onChange={handleInputChange} />
                                        {formErrors.lastName && (
                                            <div className="error-tooltip">
                                                {formErrors.lastName}
                                            </div>
                                        )}
                                    </div>

                                </div>
                                <div className={`input-group ${formErrors.address ? 'invalid' : ''}`}>
                                    <input name="address" placeholder="Street Address" required onChange={handleInputChange} />
                                    {formErrors.address && (
                                        <div className="error-tooltip">
                                            {formErrors.address}
                                        </div>
                                    )}
                                </div>
                                    <input name="apt" placeholder="Apartment, suite, etc. (optional)" onChange={handleInputChange} />
                                    <div className="grid-3">
                                        <div className={`input-group ${formErrors.city ? 'invalid' : ''}`}>
                                            <input name="city" placeholder="City" required onChange={handleInputChange} />
                                            {formErrors.city && (
                                                <div className="error-tooltip">
                                                    {formErrors.city}
                                                </div>
                                            )}
                                        </div>
                                        <div className={`input-group ${formErrors.state ? 'invalid' : ''}`}>
                                            <input name="state" placeholder="state" required onChange={handleInputChange} />
                                            {formErrors.state && (
                                                <div className="error-tooltip">
                                                    {formErrors.state}
                                                </div>
                                            )}
                                        </div>
                                        <div className={`input-group ${formErrors.zip ? 'invalid' : ''}`}>
                                            <input name="zip" placeholder="ZIP Code" required onChange={handleInputChange} />
                                            {formErrors.zip && (
                                                <div className="error-tooltip">
                                                    {formErrors.zip}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-buttons">
                                        <button type="button" onClick={() => setStep('cart')} className="back-btn">
                                            ← Back
                                        </button>
                                        <button
                                            type="button"
                                            className="cta-button"
                                            onClick={(e) => {
                                                if (validateShipping()){
                                                e.preventDefault();
                                                // Submit the hidden Netlify form
                                                document.querySelector('form[name="zenzzz-lead"]').submit();
                                                trackLeadCapture();
                                                fbq('track', 'Lead');
                                                alert('You’re on the list! We’ll email you your 20% off code when we launch.');

                                                }
                                            }}
                                        >
                                            Continue to Payment
                                        </button>

                                    </div>
                            </form>

                                <div className="payment-methods-banner">
                                    <img src={ccBanner} alt="We accept all major credit cards"  className="payment-banner-img" />

                                </div>

                                {/* HIDDEN NETLIFY FORM — sends all data silently */}
                                <form
                                    name="zenzzz-lead"
                                    method="POST"
                                    data-netlify="true"
                                    netlify-honeypot="bot-field"
                                    style={{ display: 'none' }}
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        trackLeadCapture();        // ← THIS IS IT
                                        alert('You’re on the list!');
                                    }}
                                >
                                    <input type="hidden" name="form-name" value="zenzzz-lead" />
                                    <input type="hidden" name="bot-field" />
                                    <input type="hidden" name="product" value="Zenzzz Honey Lavender"/>
                                    <input type="hidden" name="email" value={formData.email} />
                                    <input type="hidden" name="firstName" value={formData.firstName} />
                                    <input type="hidden" name="lastName" value={formData.lastName} />
                                    <input type="hidden" name="address" value={formData.address} />
                                    <input type="hidden" name="city" value={formData.city} />
                                    <input type="hidden" name="state" value={formData.state} />
                                    <input type="hidden" name="zip" value={formData.zip} />
                                    <input type="hidden" name="quantity" value={cart.quantity} />
                                    <input type="hidden" name="total" value={total.toFixed(2)} />
                                    <input
                                        type="hidden"
                                        name="subject"
                                        value={`Zenzzz Alert: ${cart.quantity} Jars Requested by ${formData.email} - Total: ${total.toFixed(2)}`}
                                    />

                                </form>
                            </>
                        )}

                        {step === 'payment' && (
                            <div className="final-preorder-step">
                                <h2>One Last Step!</h2>

                                <div className="order-preview">
                                    <img src={productImage} alt="Zenzzz" className="preview-jar" />
                                    <div className="preview-details">
                                        <p><strong>Zenzzz Lavender Honey</strong> × {cart.quantity}</p>
                                        <p className="preview-total">Total: <strong>${total.toFixed(2)}</strong></p>
                                        <p className="preview-email">We'll email you at:<br />
                                            <strong>{formData.email || 'your@email.com'}</strong>
                                        </p>
                                    </div>
                                </div>

                                <div className="sold-out-message">
                                    <p>Zenzzz is currently <strong>sold out</strong> — but we’re restocking in days!</p>
                                    <p>Be the first to know and get <strong>20% OFF</strong> your order.</p>
                                </div>



                                <button
                                    type="submit"
                                    className="cta-button full-width preorder-cta"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        document.querySelector('form[name="zenzzz-lead"]').submit();
                                        alert('You’re in! We’ll email you your 20% off code when we launch.');
                                    }}
                                >
                                    Yes! Save My Spot + 20% Off
                                </button>

                                <button
                                    type="button"
                                    onClick={() => setStep('shipping')}
                                    className="back-btn"
                                >
                                    ← Back
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Right: Order Summary */}
                    <div className="order-summary">
                        <h3>Order Summary</h3>
                        <div className="summary-row"><span>Subtotal</span><span>${subtotal.toFixed(2)}</span></div>
                        <div className="summary-row"><span>Shipping</span><span>${shipping.toFixed(2)}</span></div>
                        <div className="summary-row"><span>Tax</span><span>${tax.toFixed(2)}</span></div>
                        <div className="summary-total"><strong>Total</strong><strong>  ${total.toFixed(2)}</strong></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ShoppingCart;